export const setNumberPrecision = (val) => {
    return val && val.toFixed(2);
};
